<template>
	<div class="wrap">
		<div class="dock-item">
			<p>平台地址设置</p>
			<div class="content">
				<el-form>
					<el-form-item>
						<el-button type="primary" @click="handleDialog">添加地址</el-button>
					</el-form-item>
				</el-form>
				<el-table :data="tableData" stripe style="width: 100%" height="55vh" :header-cell-style="{
					backgroundColor: '#F9F9F9',
					color: '#333',
					fontWeight: 'bold',
					fontSize: '12px',
				}">
					<el-table-column prop="name" label="姓名">
					</el-table-column>
					<el-table-column prop="phone" label="手机号">
					</el-table-column>
					<el-table-column prop="email" label="邮箱">
					</el-table-column>
					<el-table-column label="地区">
						<template slot-scope="scope">
							{{ scope.row.province }}-{{ scope.row.city }}-{{ scope.row.district }}
						</template>
					</el-table-column>
					<el-table-column prop="address" label="详细地址">
					</el-table-column>
					<el-table-column fixed="right" label="操作">
						<template slot-scope="scope">
							<el-button type="text" disabled v-if="scope.row.isDefault">当前默认</el-button>
							<el-button type="text" v-else @click="handleSetDefault(scope.row)">设置为默认</el-button>
							<el-button type="text" @click="handleDialog(scope.row)">修改</el-button>
							<el-button type="text" @click="handleDelete(scope.row)"
								style="color: #F56C6C;">删除</el-button>
						</template>
					</el-table-column>
				</el-table>
				<div class="table-pagination">
					<el-pagination @current-change="currentChange" :current-page="page['Page.Index']"
						@size-change="sizeChange" :page-sizes="[10, 20, 50, 100]" :page-size="page['Page.Size']"
						layout="total, sizes, prev, pager, next, jumper" :total="page.pageTotal">
					</el-pagination>
				</div>
			</div>
		</div>

		<!-- 添加修改弹窗 -->
		<el-dialog :visible.sync="dialogShow" width="500px" class="address_setting-box">
			<div class="dialog-member-title">
				<span class="dialog-member-name">添加快递地址</span>
				<div class="dialog-close" @click="dialogShow = false">
					<i class="el-icon-close"></i>
				</div>
			</div>
			<div class="dialog_content">
				<el-form label-posotion="left" label-width="80px" :rules="rules" ref="formRef">
					<el-form-item label="姓名" prop="name">
						<el-input v-model="dialogData.name" placeholder="请填写姓名"></el-input>
					</el-form-item>
					<el-form-item label="手机号" prop="phone">
						<el-input v-model="dialogData.phone" maxlength="11" oninput="value=value.replace(/[^\d]/g,'')"
							placeholder="请填写手机号"></el-input>
					</el-form-item>
					<el-form-item label="邮箱" prop="email">
						<el-input v-model="dialogData.email" placeholder="请填写邮箱"></el-input>
					</el-form-item>
					<!-- 省市区 -->
					<el-form-item label="省市区" prop="district">
						<div style="display: flex;gap: 10px;">
							<div>
								<el-select v-model="dialogData.provinceId" clearable filterable placeholder="请选择省"
									@change="e => handleChangeArea(e, 'province')">
									<el-option v-for="item in provinceList" :key="item.id" :label="item.name"
										:value="item.id">
									</el-option>
								</el-select>
							</div>
							<div>
								<el-select v-model="dialogData.cityId" clearable filterable placeholder="请选择市"
									@change="e => handleChangeArea(e, 'city')">
									<el-option v-for="item in cityList" :key="item.id" :label="item.name"
										:value="item.id">
									</el-option>
								</el-select>
							</div>
							<div>
								<el-select v-model="dialogData.districtId" clearable filterable placeholder="请选择区"
									@change="e => handleChangeArea(e, 'district')">
									<el-option v-for="item in districtList" :key="item.id" :label="item.name"
										:value="item.id">
									</el-option>
								</el-select>
							</div>
						</div>
					</el-form-item>
					<el-form-item label="详细地址" prop="address">
						<el-input v-model="dialogData.address" placeholder="请填写详细地址"></el-input>
					</el-form-item>
				</el-form>
			</div>
			<!-- 底部按钮组 -->
			<div class="dialog_footer">
				<el-button @click="dialogShow = false">取消</el-button>
				<el-button type="primary" v-show="!dialogData.id" @click="handleConfirm">确定</el-button>
				<el-button type="primary" v-show="dialogData.id" @click="handleConfirmEdit">修改</el-button>
			</div>
		</el-dialog>
	</div>
</template>


<script>
import { platformaddresslist, platformaddressadd, platformaddressupdate, platformaddressdelete, platformaddressdefault, getcitylist } from '@/api/settings'
export default {
	data() {
		return {
			page: {
				"Page.Index": 1,
				"Page.Size": 10,
				pageTotal: 0
			},
			tableData: [{

			}],
			dialogShow: false,
			dialogData: {
				"name": "",
				"phone": "",
				"province": "",
				"provinceId": '',
				"city": "",
				"cityId": '',
				"district": "",
				"districtId": '',
				"address": "",
			},
			areaData: {

			},
			provinceList: [],
			districtList: [],
			cityList: [],
			rules: {
				name: [
					{ required: true, message: '请填写姓名', trigger: 'blur' },
				],
				phone: [
					{ required: true, message: '请输入手机号', trigger: 'blur' },
					{ 
					pattern: /^1[3-9]\d{9}$/,  // 手机号正则：1开头，第二位3-9，后9位任意数字
					message: '请输入合法的11位手机号', 
					trigger: ['blur', 'change'] 
					}
				],
				email: [
					{ required: true, message: '请输入邮箱地址', trigger: 'blur' },
					{
						pattern: /^[a-zA-Z0-9._%-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/,
						message: '请输入合法的邮箱地址（如：example@xxx.com）',
						trigger: ['blur', 'change']
					}
				],
				district: [
					{ required: true, message: '请选择省、市、区', trigger: 'blur' },
				],
				address: [
					{ required: true, message: '请填写详细地址', trigger: 'blur' },
				],
			}
		}
	},
	methods: {
		// 获取数据列表
		getListData() {
			platformaddresslist(this.page).then(res => {
				if (res.code == 1) {
					this.tableData = res.data.rows
					this.page.pageTotal = res.data.total
				}
			})
		},
		// 打开弹窗
		handleDialog(row = {}) {
			if (row.id) {
				// 加载地区预选数据
				this.preLoadAreaData(row)
				this.dialogData = { ...row }
			}
			this.dialogShow = true
		},
		// 获取地区列表数据
		handleGetCityList() {
			getcitylist().then(res => {
				console.log(res, 'area')
				if (res.code == 1) {
					this.areaData = res.data
					this.provinceList = res.data.province
				}
			})
		},
		// 省份框选择
		handleChangeArea(itemId, key) {
			console.log(itemId, key)
			if (itemId == '') {
				switch (key) {
					case 'province':
						this.dialogData['province'] = ''
						this.dialogData['provinceId'] = ''
						this.handleClearCity(true)
						this.handleClearDistrict(true)
						break;
					case 'city':
						this.handleClearCity()
						this.handleClearDistrict(true)
						break;
					case 'district':
						this.handleClearDistrict()
						break;
					default:
						break;
				}
				return
			}
			if (key == 'province') {
				let item = this.provinceList.find(item => item.id == itemId)
				this.dialogData[key + 'Id'] = itemId
				this.dialogData[key] = item.name
				this.cityList = this.areaData.city.filter(item => {
					return item.parentId == itemId
				})
			} else if (key == 'city') {
				let item = this.cityList.find(item => item.id == itemId)
				this.dialogData[key + 'Id'] = itemId
				this.dialogData[key] = item.name
				this.districtList = this.areaData.district.filter(item => {
					return item.parentId == itemId
				})
			} else if (key == 'district') {
				let item = this.districtList.find(item => item.id == itemId)
				this.dialogData[key + 'Id'] = itemId
				this.dialogData[key] = item.name

			}
		},
		// 清除市数据
		handleClearCity(flage = false) {
			if (flage) this.cityList = []
			this.dialogData['city'] = ''
			this.dialogData['cityId'] = ''
		},
		// 清除区数据
		handleClearDistrict(flage = false) {
			if (flage) this.districtList = []
			this.dialogData['district'] = ''
			this.dialogData['districtId'] = ''
		},
		// 点击确定按钮
		handleConfirm() {
			platformaddressadd(this.dialogData).then(res => {
				console.log(res)
				if (res.code == 1) {
					this.$message.success('添加成功')
					this.dialogData = {
						"name": "",
						"phone": "",
						"province": "",
						"provinceId": '',
						"city": "",
						"cityId": '',
						"district": "",
						"districtId": '',
						"address": "",
					}
					this.dialogShow = false
					this.getListData()
				} else {

				}
			})
		},
		// 点击修改按钮
		handleConfirmEdit() {
			platformaddressupdate(this.dialogData).then(res => {
				if (res.code == 1) {
					this.$message.success('修改成功')
					this.dialogData = {
						"name": "",
						"phone": "",
						"province": "",
						"provinceId": '',
						"city": "",
						"cityId": '',
						"district": "",
						"districtId": '',
						"address": "",
					}
					this.dialogShow = false
					this.getListData()
				} else {

				}
			})

		},
		// 点击删除内容
		handleDelete(row) {

			this.$confirm('此操作将永久删除该地址, 是否继续?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				platformaddressdelete({ id: row.id }).then(res => {
					if (res.code == 1) {
						this.$message.success('删除成功')
						this.getListData()
					} else {
						this.$message.error('删除失败')
					}
				})
			})
		},
		// 加载预选地区数据
		preLoadAreaData(row) {
			let province = this.areaData.province.find(item => {
			    return item.name == row.province
			})
			console.log(province)
			this.cityList = this.areaData.city.filter(item => {
				return item.parentId == province.id
			})
			let city = this.cityList.find(item => {
			    return item.name == row.city
			})
			this.districtList = this.areaData.district.filter(item => {
				return item.parentId == city.id
			})
			let district = this.districtList.find(item => {
			    return item.name == row.district
			})
			this.tableData = this.tableData.map(item => {
				if (item.id == row.id) {
					item.provinceId = province.id
					item.cityId = city.id
					item.districtId = district.id
				}
				return item
			})
		},
		currentChange(e) {
			this.page['Page.Index'] = e;
			this.getListData();
		},
		sizeChange(e) {
			this.page['Page.Size'] = e;
			this.getListData();
		},
		// 设置为当前默认
		handleSetDefault(row) {
			platformaddressdefault({ id: row.id }).then(res => {
				if (res.code == 1) {
					this.$message.success('设置成功')
					this.getListData()
				} else {
					this.$message.error('设置失败')
				}
			})
		}
	},
	created() {
		this.getListData()
		this.handleGetCityList()
	},
}
</script>

<style lang="scss" scoped>
.wrap {
	position: relative;

}

.dock-item {
	margin-bottom: 40px;

	p {
		font-size: 18px;
		color: #333;
		font-weight: bold;
		line-height: 20px;
		margin-bottom: 20px;
	}
}

.content {
	padding: 20px;

}

.dialog-member-title {
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin-top: -10px;

	.dialog-member-name {
		font-size: 18px;
		font-weight: bold;
	}

	.dialog-close {
		width: 25px;
		height: 25px;
		background: #e0e0e0;
		border-radius: 50%;
		display: flex;
		align-items: center;
		justify-content: center;
		cursor: pointer;

		.el-icon-close {
			color: #fff;
			font-size: 16px;
		}
	}
}

.dialog_content {
	margin-top: 25px;
}

.table-pagination {
	display: flex;
	align-items: center;
	justify-content: center;

	.el-pagination {
		height: 50px;
		margin-top: 10px;
	}
}
</style>

<style lang="scss">
.address_setting-box {
	.el-dialog {
		border-radius: 12px;
		margin-top: 15vh !important;
	}

	.el-dialog__header {
		display: none;
	}

	.el-dialog__body {
		background: linear-gradient(180deg, #e7ecfb 0%, #f6f8fe 24%, #ffffff 100%);
		border-radius: 12px;
		box-sizing: border-box;
		overflow: hidden;
	}
}
</style>